/**
 * Utility functions for filtering and organizing papers.
 */

export const DEFAULT_SCORE_THRESHOLD = 0.5;
export const MIN_EXPANDED_RESULTS = 10;

/**
 * Split papers for result display.
 *
 * Rules:
 * - Papers above the score threshold are expanded by default.
 * - If that expanded set is smaller than the minimum expanded count,
 *   promote additional lower-scoring papers in their existing order.
 */
export const splitPapersForDisplay = (
  papers,
  threshold = DEFAULT_SCORE_THRESHOLD,
  minExpandedCount = MIN_EXPANDED_RESULTS,
) => {
  if (!papers || !Array.isArray(papers)) {
    return { expandedPapers: [], collapsedPapers: [] };
  }

  const expandedPapers = [];
  const collapsedCandidates = [];

  papers.forEach((paper) => {
    const score = parseFloat(paper.relevance_score || 0);
    if (score > threshold) {
      expandedPapers.push(paper);
      return;
    }
    collapsedCandidates.push(paper);
  });

  const minimumNeeded = Math.max(0, minExpandedCount - expandedPapers.length);
  const promotedPapers = collapsedCandidates.slice(0, minimumNeeded);
  const collapsedPapers = collapsedCandidates.slice(minimumNeeded);

  return {
    expandedPapers: [...expandedPapers, ...promotedPapers],
    collapsedPapers,
  };
};
